export default "__VITE_PUBLIC_ASSET__2f591fc9__"